import { TAB_IDS, TAB_META, type TabId } from "../lib/tabs";

/**
 * Bottom channel selector — spec §2.9, §2.13.
 * Japanese character + romaji caption, always visible. Changing tabs will
 * disconnect any active session in later phases (AC-U-COM-2).
 */
export function TabNav({
  value,
  onChange,
}: {
  value: TabId;
  onChange: (v: TabId) => void;
}) {
  return (
    <nav
      className="sticky bottom-0 z-20 border-t border-ink/15 bg-cream/95 backdrop-blur-sm"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
      aria-label="Channel selector"
    >
      <ul className="grid grid-cols-3">
        {TAB_IDS.map((id) => {
          const meta = TAB_META[id];
          const active = id === value;
          return (
            <li key={id}>
              <button
                type="button"
                onClick={() => onChange(id)}
                aria-current={active ? "page" : undefined}
                className={[
                  "flex w-full flex-col items-center gap-0.5 py-3",
                  "transition-colors",
                  active ? "text-ink" : "text-subtext hover:text-ink",
                ].join(" ")}
              >
                <span
                  className={[
                    "text-lg leading-none",
                    active ? "text-rust" : "",
                  ].join(" ")}
                >
                  {meta.ja}
                </span>
                <span className="font-mono text-[11px] tracking-[0.18em]">
                  {meta.romaji}
                </span>
                <span
                  className={[
                    "mt-1 h-0.5 w-8 transition-colors",
                    active ? "bg-rust" : "bg-transparent",
                  ].join(" ")}
                />
              </button>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
